import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { Userdetails } from '../../../interface/temporaryredelegation/userdetails';
import { UserTempDOA } from '../../../interface/temporaryredelegation/user-temp-doa';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { Redelegation } from '../../../interface/temporaryredelegation/redelegation';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedServices } from '../../../shared/services/shared.services';
import { RoleService } from '../../../shared/services/RoleService';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { TempRedelEmployeedetails} from '../../../interface/delegationofauthority/employeedetails';
import { LookupComponent } from '../../../shared/component/look-up/lookup.component';
@Component({
  selector: 'app-enterredelegation',
  imports: [ReactiveFormsModule, CommonModule, FormsModule, MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    LookupComponent,],
  templateUrl: './enterredelegation.component.html',
  styleUrl: './enterredelegation.component.css'
})
export class EnterredelegationComponent implements AfterViewInit {
  delegations: Redelegation[] = [];
  dataSource = new MatTableDataSource<Redelegation>([]);
  modalCloseEvent: EventEmitter<void> = new EventEmitter<void>();
  form!: FormGroup;
  userdetails: Userdetails[] = [];
  tempDOA: UserTempDOA[] = [];
  UserEmail: string = '';
  approverEmail:string='';
  startDate: string = '';
  isUpdateRequest: boolean = false;
  today: string = '';
  displayedColumns1: string[] = ['sno', 'toName', 'dueTo', 'startDate', 'endDate'];
  //showRadioWarning: boolean=false;
  selectedRadioReason: string = '';
  //@ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  otherreason: string = '';
  delegatorShowWarning: boolean = false;
  delegateeShowWarning: boolean = false;
  isNewRequest: boolean = true;
  isDateConflict: boolean = false;
  isRedirected: boolean = true;
  showElement: boolean = true;
  isAdmin: boolean = false;
  buttonLabel: string = 'Show Previous Delegations';
  displayStyle: string = 'none';
  delUserEmail: string = '';
  showContent: boolean = false;
  isOtherReasonSelected = false;
  enterTempDOAGridOptions: any = {};
  inputLabel: string = 'Approval By:';
  approvername: string = '';
  warningMessage: string | undefined;
  isDuplicateCAI: boolean = false;
  isGridDataAvailable: boolean = false;
  isInitialLoad: boolean = true;
  isCheckboxChecked: boolean = false;
  fromEmpno: string = '';
  toEmpno: string = '';
  approvercai: string = '';
  joblocation: string = '';
  public paginator!: MatPaginator;
  isApproverMatching:boolean=false;
  isLoading: boolean = false;
  hasRoleA: boolean = false;
  submitFormFlag : boolean = false;
  clearSearch: boolean = false; 
  loggedUserEmail: string='';
  selectedReason: string | null = null;
  employeeDetails: TempRedelEmployeedetails = {
    employeeNo: '',
    surname: '',
    initials: '',
    jobTitle: '',
    phoneext: '',
    preferredname: '',
    reportstocai: '',
    locationName: '',
    fullName: '',
    reportsToCAI: '',
    divisionID: '',
    deptID: '',  
    reportsToEmpNo:'',
    reportsToEmailAddress:'',
    emailAddress:'',
    cai:'',
  };
  inputValues: { [key: string]: string } = {};
  approverEmail1: any;
  loggedUserCAI: string='';
  @ViewChild('lookupComponent') lookupComponent!: LookupComponent;
  constructor(private fb: FormBuilder,
    private tempdelegationService: TemporaryRedelegationService,
    private route: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sharedServices: SharedServices,
    private roleService: RoleService,
    private delegationService: DelegationofauthorityService
  ) {
    this.form = this.fb.group({});
    this.modalCloseEvent.subscribe(() => {
      this.router.navigate(['/DOA']);
    });
    //this.today = new Date().toString().split('T')[0]; // Set today's date in YYYY-MM-DD format
  }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  ngOnInit(): void {
    this.isLoading = false;
    this.loggedUserEmail =this.sharedServices.getloggedUserEmail();
    this.loggedUserCAI = this.sharedServices.getloggedUserCai();
    if (this.loggedUserEmail) {
      this.loadData(this.loggedUserEmail);
    }
    this.dataSource.paginator = this.paginator;
      this.form = this.fb.group({
        name: ['', Validators.required],
        jobTitle: ['', Validators.required],
        UserEmail: ['', [Validators.required, Validators.email]],
        deptID: [''],
        divisionID: [''],
        otherReason: [{ value: '', disabled: true }],
        reasons: this.fb.array([], Validators.required),
        jobLocation: ['', Validators.required],
        fromEmpno: [],
        approverEmpNo: [''],
        approverEmail: [''],
        approvername: [''],
        userCAI: [''],
        reporterEmail: [''],
      });
      this.form.get('UserEmail')?.valueChanges.subscribe(value => {
        if (!value) {
          this.form.reset();
        }
      });
    
      this.today = new Date().toISOString().split('T')[0];  
      this.form.get('reasons')?.valueChanges.subscribe(value => {
        this.isOtherReasonSelected = value.includes('other');
        if (this.isOtherReasonSelected) {
          this.form.get('otherReason')?.setValidators([Validators.required]);
          this.form.get('otherReason')?.enable();
        } else {
          this.form.get('otherReason')?.clearValidators();
          this.form.get('otherReason')?.disable();
          this.form.get('otherReason')?.reset();
        }
        this.form.get('otherReason')?.updateValueAndValidity();
      });
    
      this.initializeGridOptions(this.isNewRequest);
      this.sharedServices.hasRoleA(this.roleService).subscribe(hasRole => {
        this.hasRoleA = hasRole;
      });
    }
  get reasons(): FormArray {
    return this.form.get('reasons') as FormArray;
  }
  onCheckboxChange(event: any): void {
    const reasons = this.reasons;
    if (event.target.checked) {
      reasons.push(new FormControl(event.target.value));
      if (event.target.value === 'other') {
        this.isOtherReasonSelected = true;
        this.form.get('otherReason')?.setValidators([Validators.required]);
        this.form.get('otherReason')?.enable();
      }
    } else {
      const index = reasons.controls.findIndex(x => x.value === event.target.value);
      reasons.removeAt(index);
      if (event.target.value === 'other') {
        this.isOtherReasonSelected = false;
        this.form.get('otherReason')?.clearValidators();
        this.form.get('otherReason')?.disable();
        this.form.get('otherReason')?.reset();
      }
    }
    this.form.get('otherReason')?.updateValueAndValidity();
  }

  loadData(email: string) {
    this.isLoading = true;
    this.tempdelegationService.getEmployeeDetails(email).subscribe(
      (data: any) => {
        if (data) {
          const employeeDetails = data; 
          this.employeeDetails = employeeDetails;
          this.form.patchValue({
            UserEmail: this.loggedUserEmail,
            name: this.employeeDetails.fullName,
            jobTitle: this.employeeDetails.jobTitle,
            fromEmpno: this.employeeDetails.employeeNo,
            divisionID: this.employeeDetails.divisionID,
            deptID: this.employeeDetails.deptID,
            userCAI: this.employeeDetails.cai,
            reportsToCAI: this.employeeDetails.reportsToCAI,
            approverEmpNo: this.employeeDetails.reportsToEmpNo,
            approverEmail: this.employeeDetails.reportsToEmailAddress,
            reporterEmail: this.employeeDetails.reportsToEmailAddress,
          });
          this.onApproverSelected({ emailAddress: this.employeeDetails.reportsToEmailAddress });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.lookupComponent.mainSearchText = '';
          this.sharedServices.openModal('Message', 'Loggedin user Data not found or is not a permanent employee');
          //this.router.navigate(['error']);
      }
      }
    );
  }
  updateFormValues(event: any): void {
    this.clearGrid(); 
    this.form.reset();
    const isChecked = (event.target as HTMLInputElement).checked;
    this.inputLabel = isChecked ? 'Approval Email' : 'Approval By';
    this.approvername = isChecked ? '' : this.approvername;
    this.isAdmin = !this.isAdmin;
    this.isCheckboxChecked = isChecked; 
    this.form.get('UserEmail')?.setValue(isChecked ? 'DOA_ADMIN_DUMMY_CAI' : '');
    this.form.get('name')?.setValue(isChecked ? 'DOA Custodian/Administrator' : '');
    this.form.get('approverEmail')?.setValue('');
    this.showContent = false;
    this.buttonLabel = this.showContent ? 'Hide Previous Delegations' : 'Show Previous Delegations';
    this.form.get('otherReason')?.setValue('');
    this.isOtherReasonSelected = false;
    this.reasons.clear(); 
    const reasonCheckboxes = document.querySelectorAll('input[type="checkbox"][value]');
    reasonCheckboxes.forEach((checkbox) => {
        (checkbox as HTMLInputElement).checked = false;
    });
    if (!isChecked) {
      this.isLoading = false;
      this.loadData(this.loggedUserEmail);
    } 
}
  onApproverSelected(selectedResult: any): void {
    this.isLoading = true;
      if (selectedResult && selectedResult.emailAddress) {
        this.form.patchValue({
          approverEmail: selectedResult.emailAddress
        });
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Approver Details not found');
      }
  }
  onDelegateeSelected(selectedResult: any, currentIndex: number): void {
    this.isLoading = true;
    if (selectedResult && selectedResult.emailAddress) {
      this.enterTempDOAGridOptions.data[currentIndex].Email = selectedResult.emailAddress;
      this.onEmailChange(this.enterTempDOAGridOptions.data[currentIndex], currentIndex);
      this.isLoading = false;
    } else {
      this.isLoading = false;
      this.sharedServices.openModal('Message', 'Delegatee Details not found');
    }
  }
  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }
  onJobLocationChange(event: any) {
    this.joblocation = event.target.value;
  }
  @HostListener('input', ['$event']) onInputEvent(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const fieldName = inputElement.getAttribute('formControlName');   
  }
  removeDOARow(row: any): void {
    const index = this.enterTempDOAGridOptions.data.indexOf(row);
    if (index > -1) {
      this.enterTempDOAGridOptions.data.splice(index, 1);
    }
  }
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart;
    const fieldName = inputElement.id;
    this.inputValues[fieldName] = inputElement.value;
    setTimeout(() => {
      inputElement.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  }
  get approvernameControl(): FormControl {
    return this.form.get('approvername') as FormControl;
  }
  alphabeticValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valid = /^[a-zA-Z\s]*$/.test(control.value);
      return valid ? null : { alphabetic: true };
    };
  }
  approverValidation(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const approverEmail = this.form.get('approverEmail')?.value;
      if (approverEmail) {
          this.tempdelegationService.getEmployeeDetails(approverEmail).subscribe(
            (data: any) => {
              if (data) {
                resolve(true);
              } else {
                this.isLoading = false;
                resolve(false);
              }
            },
            (error) => {
              reject(error);
            }
          );
      } else {
        resolve(false);
      }
    });
  }
  async submitForm() {
    this.isLoading = true;
    if (this.submitFormFlag) {
      if (this.form.invalid && !this.isAdmin) {
        this.form.markAllAsTouched();
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'All fields in the form are required.');
        return;
      }
      const approverEmail = this.form.get('approverEmail')?.value;
      const userEmail = this.form.get('UserEmail')?.value;
      if (!approverEmail) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Approver email is required.');
        return;
      }
      const appresult = await this.approverValidation();
      if (!appresult) {
        this.sharedServices.openModal('Message', 'Approver should be same department of delegator or not a permanent employee');
        return;
      }
      if (this.reasons.length === 0) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Please select at least one reason.');
        return;
      }
      if (this.isOtherReasonSelected && this.form.get('otherReason')?.invalid) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Please provide a reason for "other".');
        return;
      }
      if (this.enterTempDOAGridOptions.data.length === 0) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'You must enter at least one delegation entry.');
        return;
      }
      const isGridValid = this.enterTempDOAGridOptions.data.every((row: any) => {
        return row.EmployeeNo && row.Email && row.Name && row.StartDate && row.EndDate;
      });
      if (!isGridValid) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'All fields in the grid are required.');
        return;
      }
      const jobtitle = this.form.get('jobTitle')?.value;
      const joblocation = this.form.get('jobLocation')?.value;
      const selectedReason = this.form.get('reasons')?.value;
      const finalReason = selectedReason.includes('other') ? [...selectedReason.filter((reason: string) => reason !== 'other'), this.form.get('otherReason')?.value] : selectedReason;
      if (this.isAdmin) {
        if (!jobtitle || !joblocation || !finalReason) {
          this.isLoading = false;
          this.sharedServices.openModal('Message', 'All the fields are required.');
          return;
        }
      }
      const isApproverEmailInGrid = this.enterTempDOAGridOptions.data.some((row: any) => {
        return row.Email?.trim().toLowerCase() === approverEmail.trim().toLowerCase();
      });
  if(!this.form.controls['jobTitle'].value.toLowerCase().includes('managing director') &&
  (approverEmail.trim().toLowerCase() === userEmail.trim().toLowerCase())){
      if (approverEmail.trim().toLowerCase() === userEmail.trim().toLowerCase() || isApproverEmailInGrid) {
        this.isLoading = false;
        this.sharedServices.openModal('Message', 'Approver email should not be the same as delegator or the delegatee.');
        return;
      }}
      const TempDOADetails = this.enterTempDOAGridOptions.data.map((row: any) => ({
        FromEmpno: this.form.get('fromEmpno')?.value,
        ToEmpno: row.EmployeeNo,
        FromCAI: this.form.get('userCAI')?.value,
        EnteredByCAI: this.loggedUserCAI,
        ToCAI: row.CAI,
        reportsToCAI: this.form.get('reportsToCAI')?.value,
        DueTo: finalReason.join(', '),
        EndDate: row.EndDate,
        FromEmail: this.form.get('UserEmail')?.value,
        FromName: this.form.get('name')?.value,
        FromJobtitle: this.form.get('jobTitle')?.value,
        StartDate: row.StartDate,
        ToEmail: row.Email,
        ToName: row.Name,
        isAdmin: this.isAdmin,
        ApproverEmail: this.form.get('approverEmail')?.value,
        JobLocation: this.form.get('jobLocation')?.value,
      }));
      this.tempdelegationService.saveRedelegation(TempDOADetails).subscribe({
        next: response => {
          this.isLoading = false;
          this.sharedServices.openModal('Message', 'Record saved successfully!');
          this.modalCloseEvent.emit();
        },
        error: error => {
          this.isLoading = false;
          this.sharedServices.openModal('Message', 'Error adding redelegation details');
          this.modalCloseEvent.emit();
        }
      });
    }
  }
  Searchuser(email:string) {
    this.isLoading = true;
    if (!email) {
      this.isLoading = false;
      this.form.reset();
      return;
    }
    else {
      
      this.tempdelegationService.getEmployeeDetailsByEmail(email).subscribe(
        (data: any) => {
          if(data){
          const employeeDetails = data; 
          this.employeeDetails = employeeDetails;
          this.form.patchValue({
            name: this.employeeDetails.fullName,
            jobTitle: this.employeeDetails.jobTitle,
            fromEmpno: this.employeeDetails.employeeNo,
            divisionID: this.employeeDetails.divisionID,
            deptID: this.employeeDetails.deptID,
            userCAI:this.employeeDetails.cai,
            reportsToCAI: this.employeeDetails.reportsToCAI,
            approverEmpNo: this.employeeDetails.reportsToEmpNo,
            approverEmail: this.employeeDetails.reportsToEmailAddress,
            reporterEmail: this.employeeDetails.reportsToEmailAddress,
          });
          this.isLoading = false;
          this.onApproverSelected({ emailAddress: this.employeeDetails.reportsToEmailAddress });
        }
          else{
            this.isLoading = false;
            this.sharedServices.openModal('Message', 'User Data not found or User is not a permanent employee');
            //this.loadData(this.loggedUserEmail);
            //this.router.navigate(['error']);
          }
         });
    } 
  }
  initializeGridOptions(isEditable: boolean): void {
    this.enterTempDOAGridOptions = {
      columnDefs: [
        { field: 'SerialNo', displayName: 'S/No' },
        { field: 'Email', displayName: 'Email' },
        { field: 'Name', displayName: 'Name' },
        { field: 'StartDate', displayName: 'Start Date' },
        { field: 'EndDate', displayName: 'End Date' },

        ...(isEditable ? [{ field: 'Remove', displayName: 'Remove' }] : []),
      ],
      data: [],
    }
    this.enterTempDOAGridOptions.data.forEach((row: { warningMessage: string; isDateInRange: boolean; }) => {
      row.isDateInRange = false;
      row.warningMessage = '';
    });
    this.isGridDataAvailable = this.enterTempDOAGridOptions.data.length > 0;
    this.isInitialLoad = false;
  }

  showDelegation() {
    this.isLoading = true;
    this.showContent = !this.showContent;
    this.buttonLabel = this.showContent ? 'Hide Previous Delegations' : 'Show Previous Delegations';
    this.tempdelegationService.showReDelegations(this.UserEmail).subscribe((data: Redelegation[]) => {
      if (data) {
        this.dataSource.data = data;
        this.setDataSourceAttributes();
        this.isLoading = false;
      }
    });
  }
 
  clearGrid(){
    this.enterTempDOAGridOptions.data = [];
    this.isGridDataAvailable = false;
    this.cdr.detectChanges();
}

searchDelegatee(delgateeEmail: string, currentIndex: number) {
  this.isLoading = true;
  if (!delgateeEmail) {
    this.isLoading = false;
    return;
  }
  const delegatorEmail = this.form.get('UserEmail')?.value?.trim().toUpperCase();
  const delgatorDeptId = this.form.get('deptID')?.value?.trim().toUpperCase();
  const delegatorDivisionId = this.form.get('divisionID')?.value?.trim().toUpperCase();
  const approverEmail = this.form.get('approverEmail')?.value?.trim().toUpperCase();
  const jobTitle = this.form.get('jobTitle')?.value?.toLowerCase(); // Get jobTitle value

  const isDelegatorMatchingCAI = this.enterTempDOAGridOptions.data.some(
    (row: { Email: string }) => row.Email && row.Email.trim().toUpperCase() === delegatorEmail
  );
  if (isDelegatorMatchingCAI) {
    this.isLoading = false;
    this.sharedServices.openModal('Message', 'Delegator and Delegatee should not be same');
    return;
  }

  // Check if jobTitle contains "managing director" in non-admin scenario
  if (!this.isAdmin && jobTitle.includes('managing director')) {
    this.tempdelegationService.getEmployeeDetails(delgateeEmail).subscribe(
      (data: any) => {
        if (data) {
          this.employeeDetails = data;
          const row = this.enterTempDOAGridOptions.data[currentIndex];
          row.Name = this.employeeDetails.fullName;
          row.EmployeeNo = this.employeeDetails.employeeNo;
          row.CAI = this.employeeDetails.cai;
          this.cdr.detectChanges();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.sharedServices.openModal('Message', 'Provided Delegatee not found or not a permanent employee');
        }
      },
      (error) => {
        this.isLoading = false;
        this.sharedServices.openModal('Error', 'Failed to fetch employee details.');
      }
    );
    return; // Skip further processing
  }

  if (this.isAdmin) {
    this.tempdelegationService.getEmployeeDetails(delgateeEmail).subscribe(
      (data: any) => {
        if (data) {
          this.employeeDetails = data;
          const row = this.enterTempDOAGridOptions.data[currentIndex];
          row.Name = this.employeeDetails.fullName;
          row.EmployeeNo = this.employeeDetails.employeeNo;
          row.CAI = this.employeeDetails.cai;
          this.cdr.detectChanges();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.sharedServices.openModal('Message', 'Provided Delegatee not found or not a permanent employee');
        }
      }
    );
  } else {
    if (delegatorEmail) {
      this.tempdelegationService.getUserbyDept(delegatorEmail, delgateeEmail, delgatorDeptId, delegatorDivisionId).subscribe(
        (data: any) => {
          if (data) {
            this.employeeDetails = data;
            const row = this.enterTempDOAGridOptions.data[currentIndex];
            row.Name = this.employeeDetails.fullName;
            row.EmployeeNo = this.employeeDetails.employeeNo;
            row.CAI = this.employeeDetails.cai;
            this.cdr.detectChanges();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            const row = this.enterTempDOAGridOptions.data[currentIndex];
            row.Name = '';
            this.sharedServices.openModal(
              'Message',
              'Provided Delegatee not found or not a permanent employee or not in the same department and division'
            );
          }
        }
      );
    } else {
      this.isLoading = false;
      this.sharedServices.openModal('Message', 'Please enter delegator');
    }
  }
}
  
  compareDates(row: any, index: number) {
    const delegator = this.form.get('UserEmail')?.value?.trim().toUpperCase();
    const enteredStartDate = row.StartDate ? new Date(row.StartDate).setHours(0, 0, 0, 0) : null;
    const enteredEndDate = row.EndDate ? new Date(row.EndDate).setHours(0, 0, 0, 0) : null;
    this.tempdelegationService.getDelegatorDelegations(delegator).subscribe((delegations: Redelegation[]) => {
      if (delegations && delegations.length > 0) {
          delegations.forEach((delegation) => {
              const delegationStartDate = new Date(delegation.startDate).setHours(0, 0, 0, 0);
              const delegationEndDate = new Date(delegation.endDate).setHours(0, 0, 0, 0);

              if (
                  enteredStartDate && enteredEndDate &&
                  (
                      (enteredStartDate >= delegationStartDate && enteredStartDate <= delegationEndDate) ||
                      (enteredEndDate >= delegationStartDate && enteredEndDate <= delegationEndDate) ||
                      (enteredStartDate <= delegationStartDate && enteredEndDate >= delegationEndDate)
                  )
              ) {
                this.sharedServices.openModal('Message', 'Delegator already have an active delegation in selected dates, so can\'t delegate to others.');
                row.StartDate = '';
                row.EndDate = '';
            }
        });
    }
      this.cdr.detectChanges(); 
    });
    // Check for overlaps with previous grid values
    let isDateConflict = false;
    this.enterTempDOAGridOptions.data.forEach((gridRow: any, gridIndex: number) => {
      if (gridIndex !== index) { // Compare with all other rows except the current one
        const gridStartDate = gridRow.StartDate ? new Date(gridRow.StartDate).setHours(0, 0, 0, 0) : null;
        const gridEndDate = gridRow.EndDate ? new Date(gridRow.EndDate).setHours(0, 0, 0, 0) : null;
  
        if (enteredStartDate && enteredEndDate && gridStartDate && gridEndDate) {
          if (
            (enteredStartDate >= gridStartDate && enteredStartDate <= gridEndDate) ||
            (enteredEndDate >= gridStartDate && enteredEndDate <= gridEndDate) ||
            (enteredStartDate <= gridStartDate && enteredEndDate >= gridEndDate)
          ) {
            isDateConflict = true;
          }
        }
      }
    });
  
    // Check for overlaps with existing records from the API
    /* this.tempdelegationService.showDelegateeDelegations(row.Email).subscribe((data: Redelegation[]) => {
      debugger
      if (data && data.length > 0) {
        data.forEach((record) => {
          const apiStartDate = new Date(record.startDate).setHours(0, 0, 0, 0);
          const apiEndDate = new Date(record.endDate).setHours(0, 0, 0, 0);
           let reqStatus=record.reqStatus;
          if (enteredStartDate && enteredEndDate) {
             if (
              (enteredStartDate >= apiStartDate && enteredStartDate <= apiEndDate) ||
              (enteredEndDate >= apiStartDate && enteredEndDate <= apiEndDate) ||
              (enteredStartDate <= apiStartDate && enteredEndDate >= apiEndDate) && (reqStatus=="RS"|| reqStatus=="AP")
            ) {
              isDateConflict = true;
            }
            
          }
        });
      } */

          this.tempdelegationService.showDelegateeDelegations(row.Email).subscribe((data: Redelegation[]) => {
      debugger;
      if (data && data.length > 0) {
        data.forEach((record) => {
          
          const apiStartDate = new Date(record.startDate).setHours(0, 0, 0, 0);
          const apiEndDate = new Date(record.endDate).setHours(0, 0, 0, 0);
           let reqStatus=record.reqStatus;
          if (enteredStartDate && enteredEndDate) {
             const isDateOverlap =
  (enteredStartDate >= apiStartDate && enteredStartDate <= apiEndDate) ||
  (enteredEndDate >= apiStartDate && enteredEndDate <= apiEndDate) ||
  (enteredStartDate <= apiStartDate && enteredEndDate >= apiEndDate);
               if (isDateOverlap) 
                {
                  if(reqStatus === "RS" || reqStatus === "AP")
                  {
                    isDateConflict = true;

                  }
   
 } else {
   isDateConflict = false; // Explicitly set to false when conditions are not met
 }
              
            
            
          }
        });
      } 
  
      if (isDateConflict) {
        this.sharedServices.openModal('Message', 'There exist an Overlapping in the selected Dates!');
        row.StartDate = '';
        row.EndDate = '';
      }
  
      row.isStartDateInRange = isDateConflict;
      row.isEndDateInRange = isDateConflict;
      this.isDateConflict = isDateConflict;
      this.cdr.detectChanges(); // Ensure the view is updated
    });
  }
  addNewRow(): void {
    const lastRow = this.enterTempDOAGridOptions.data[this.enterTempDOAGridOptions.data.length - 1];
    const newStartDate = lastRow ? new Date(lastRow.EndDate) : new Date();
    newStartDate.setDate(newStartDate.getDate() + 1);

    const newRow = {
      CAI: '',
      Name: '',
      StartDate: newStartDate.toString().split('T')[0], // Format date as YYYY-MM-DD
      EndDate: '',
      editMode: true,
      isStartDateInRange: false,
      isEndDateInRange: false,
      isDateInRange: false,
      warningMessage: '',
      caiWarningMessage: ''
    };
    this.enterTempDOAGridOptions.data.push(newRow);
    this.isGridDataAvailable = this.enterTempDOAGridOptions.data.length > 0;
  }
 
  onEmailChange(row: any, index: number): void {
    this.isLoading = true;
    const approverEmail= this.form.get('approverEmail')?.value;
    const reporterEmail= this.form.get('reporterEmail')?.value;
    if (!row.Email || row.Email.trim().length === 0) {
      this.isLoading = false;
      return;
    }
    else {
      if(approverEmail===row.Email || reporterEmail===row.Email){
        this.sharedServices.openModal('Message','Supervisor  or Approver should not be used as delegatee');
        this.isLoading = false;
        row.Email='';
        return;}
      // const isDuplicate = this.checkForDuplicateCAI(row.Email, index);
      // if (isDuplicate) {
      //   this.sharedServices.openModal('Message', 'Duplicate delegatee found');
      //   this.isLoading = false;
      //  row.Email='';
      // }
       
        row.caiWarningMessage = '';
        this.isDuplicateCAI = false;
        this.searchDelegatee(row.Email, index);
       
    }
  }
  checkForDuplicateCAI(newCAI: string, currentIndex: number): boolean {
    if (currentIndex === 0) {
      return false;
    }
    return this.enterTempDOAGridOptions.data.some((row: { Email: string }, index: number) => {
      return row.Email && row.Email.trim().toUpperCase() === newCAI.trim().toUpperCase() && index !== currentIndex;
    });
  }
  cancelRequest(): void {
   this.modalCloseEvent.emit();
    }

  hasFutureStartDate(): boolean {
    const today = new Date().toISOString().split('T');
    return this.enterTempDOAGridOptions.data.some(
      (row: any) => row.StartDate > today
    );
  }
}


